import {ActionList} from '@primer/react'
import {PullRequestStateIcons} from '@github-ui/timeline-items'
import {type PullRequestPickerPullRequest$data, getPrIconColor, getPrState} from '@github-ui/item-picker/pr'

type LinkedPullRequestsProps = {
  linkedPullRequests: PullRequestPickerPullRequest$data[]
}

export function LinkedPullRequests({linkedPullRequests}: LinkedPullRequestsProps) {
  return (
    <>
      {linkedPullRequests.map(pullRequest => {
        return (
          <ActionList.LinkItem href={pullRequest.url} target="_blank" key={pullRequest.id}>
            <ActionList.LeadingVisual
              sx={{
                color: getPrIconColor(pullRequest),
              }}
            >
              {getPrIcon(pullRequest)}
            </ActionList.LeadingVisual>
            {pullRequest.title}
            <ActionList.Description variant="block">{pullRequest.repository.nameWithOwner}</ActionList.Description>
          </ActionList.LinkItem>
        )
      })}
    </>
  )
}

function getPrIcon(pullRequest: PullRequestPickerPullRequest$data) {
  const item = PullRequestStateIcons[getPrState(pullRequest.state)]!
  return <item.icon />
}

try{ LinkedPullRequests.displayName ||= 'LinkedPullRequests' } catch {}